export default "__VITE_ASSET__DfPKUhbG__"